import JSzip from 'jszip';
import FileSaver from 'file-saver';
import remoteFileItemReader from './remote-file-item-reader';

export default {
  downloadAndZip(files) {
    return new Promise((resolve, reject) => {
      this.download(files)
        .then(() => {
          const zip = new JSzip();

          files.forEach((file) => {
            if (file.blob) {
              zip.file(file.path, file.blob);
            } else {
              zip.file(file.path, file.content);
            }
          });

          zip
            .generateAsync({ type: 'blob' })
            .then((content) => {
              FileSaver.saveAs(content, 'source.zip');
              resolve();
            })
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error));
    });
  },

  download(files) {
    const promises = [];

    files.forEach((file) => {
      if (!file.content) {
        promises.push(remoteFileItemReader.read(file));
      }
    });

    return Promise.all(promises);
  },
};
